import { range } from 'lodash';
import React from 'react';
import Table from '@splunk/dashboard-visualizations/Table';

export default () => (
    <Table
        options={{
            dataOverlayMode: 'highlow',
        }}
        encoding={{
            columns: ['primary.foo', 'primary.sparkline'],
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'foo' }, { name: 'sparkline' }],
                    columns: [
                        range(10),
                        range(10).map(() => [
                            '##__SPARKLINE__##',
                            '0',
                            '0',
                            '0',
                            '0',
                            '0',
                            '29279',
                            '106078',
                            '175560',
                            '0',
                            '0',
                            '0',
                        ]),
                    ],
                },
                meta: { totalCount: 30 },
            },
        }}
    />
);
